
export const EVENT_USER_LANGUAGE_CHANGED = 'rio.core.user.language.changed';

export const EVENT_USER_LOGGED_OUT = 'rio.core.user.loggedout';

export const EVENT_USER_PROFILE_CHANGED = 'rio.core.user.profile.changed';
